import React from 'react';
import { Card, Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;

function Downloads() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.split('/')[2];
  const currentTab = currentPath || 'course-download';

  const tabKeyMap = {
    'course-download': '1',
    'package-download': '2',
    'livetest-download': '4',
    'quiz-download': '5',
    'course-quiz-download': '6',
  };

  const keyTabMap = {
    '1': 'course-download',
    '2': 'package-download',
    '4': 'livetest-download',
    '5': 'quiz-download',
    '6': 'course-quiz-download',
  };
  

  React.useEffect(() => {
    if (location.pathname === '/download') {
      navigate('/download/course-download', { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (key) => {
    navigate(`/download/${keyTabMap[key]}`);
  };

  const activeKey = tabKeyMap[currentTab];

  return (
    <div className="lms-body">
      <Card>

        <h2 style={{ marginBottom: "20px" }}>
          Download reports
        </h2>

        <Tabs activeKey={activeKey} onChange={handleTabChange}>
          <TabPane tab="Course download" key="1" />
          <TabPane tab="Package download" key="2" />
          {/* <TabPane tab="Live Test download" key="4" /> */}
          <TabPane tab="Quiz download" key="5" />
          <TabPane tab="Course Quiz download" key="6" />
        </Tabs>

        <Outlet />
      </Card>
    </div>
  );
}

export default Downloads;
